import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { ISimApnModel } from '@apps-common/types/management/sim-apn'

export const createSimApn = async (model: ISimApnModel): Promise<ISimApnModel> =>
  axios.post(`/management/simapn/addsimapn`, model).then((res) => res?.data?.data)

type Props = {
  model: ISimApnModel
}

export const useManagementCreateSimApn = (notify?: boolean, onSuccess?: (data: ISimApnModel) => void) =>
  useMutation({
    mutationKey: ['createSimApn'],
    mutationFn: ({ model }: Props) => createSimApn(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Created sim apn.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to create sim apn, please try again.')
      }
    },
    throwOnError: false
  })
